import { enumFontIconWeights, kfontIconName } from "../constants";

export function fontIconString(size, weight, style) {
  var styleName = style ? style : kfontIconName;
  var weightStr = enumFontIconWeights.regular;
  var sizeStr = "18";
  if (weight != null) weightStr = weight.toString();
  if (size != null) sizeStr = size.toString();
  return weightStr + " " + sizeStr + "px " + '"' + styleName + '"';
}
